import type { OnInit } from '@angular/core';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject, take } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ShopCartIconFacade } from '@web/store/shop-cart-icon/shop-cart-icon.facade';
import { RouterFacade } from '@web/store/router/router.facade';
import { EIconPosition } from '@common/enums/icon-position.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-delete-shared-block-modal',
    templateUrl: './delete-shared-block-modal.component.html',
    styleUrls: ['./delete-shared-block-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule],
})
export class DeleteSharedBlockModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);
    protected readonly shopCartIconFacade = inject(ShopCartIconFacade);
    protected readonly routerFacade = inject(RouterFacade);

    public type: 'header' | 'footer' = 'header';
    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        if (this.type === 'header') {
            this.shopCartIconFacade.cartIconData$.pipe(take(1)).subscribe((data) => {
                this.shopCartIconFacade.saveCartIcon({ ...data, ...{ iconPositionType: EIconPosition.SITE } });
            });
        }

        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public get titleText(): string {
        if (this.type === 'header') {
            return 'shared_block_header_delete';
        }

        return 'shared_block_footer_delete';
    }

    public get bodyText(): string {
        if (this.type === 'header') {
            return 'shared_block_header_delete_description';
        }

        return 'shared_block_footer_delete_description';
    }
}
